// LoadingSpinner.js
import React, { useEffect, useState } from "react";
import { subscribe, unsubscribe } from "./LoadingManager";
import loadingGif from "../../assets/loader/loader.gif"; // Assicurati che il percorso sia corretto

const LoadingSpinner = () => {
    const [isLoading, setIsLoading] = useState(false);
  
    useEffect(() => {
      const handleLoading = (loadingState) => {
        setIsLoading(loadingState);
      };
      subscribe(handleLoading);
      return () => {
        unsubscribe(handleLoading);
      };
    }, []);
  
    if (!isLoading) return null;
  
    return (
      <div className="spinner-overlay">
        <img src={loadingGif} alt="Loading..." width="125"  />
      </div>
    );
  };
  
  export default LoadingSpinner;